export default __webpack_public_path__ + "static/media/3.4c15a563.jpg";